import { type QueryClient } from '@tanstack/react-query';

import { getData } from 'api/requests/GET_APP_PROGRESS';

import { getQueryKey } from 'helpers/getQueryKey';
import { localStorage } from 'helpers/localStorage';

type Params = { resource: string | string[] };

export const getAppProgressOptions = (params: { resource: string | string[] }) => {
  const user = localStorage.get('USER');

  if (user === undefined) {
    throw new Error('User not logged in');
  }

  const resourceParams = [params.resource].flat().reduce((acc, resource) => {
    return {
      ...acc,
      [resource]: true,
    };
  }, {});

  return {
    queryKey: getQueryKey('PROGRESS', user.email, resourceParams),
    queryFn: async () => {
      try {
        const result = await getData({
          resource: params.resource,
          email: user.email,
        });

        if (result === undefined) {
          return [];
        }

        return result;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
  };
};

export const queryAppProgress = async (client: QueryClient, params: Params) => {
  return client.ensureQueryData({
    revalidateIfStale: true,
    ...getAppProgressOptions(params),
  });
};
